import NavComponent from 'app/components/NavComponent/NavComponent';
import GuardedRoute from 'app/guard/GuardedRoute';
import GuestGuardedRoute from 'app/guard/GuestGuardedRoute';
import {
	IRoute,
	IRouteChild,
	IRouteGrandChild,
} from 'app/interfaces/route-interface/route.interface';
import { RootState } from 'app/redux/store';
import {
	guestOnlyRoutes,
	privateRoutes,
	privateRouteWithoutSidebar,
	routes,
} from 'app/routes/router';
import ROUTER_PATH from 'app/routes/routerPath';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './AppComponent.scss';
import LocalStorageService from 'app/services/localStorage';

const AppComponent = function init(): React.ReactElement {
	const navHeaderState = useSelector(
		(state: RootState) => state.navHeaderReducer
	);
	const { navIsShown } = navHeaderState;
	const isLoggedIn = LocalStorageService.isLoggedIn();

	function setGrandChildRoutes(child: IRouteChild): React.ReactElement {
		return (
			<Route key={child.path} path={child.path} element={child.component}>
				{child.child !== null &&
					child.child?.map((r: IRouteGrandChild) => (
						<Route
							key={r.path}
							path={r.path}
							element={r.component}
						/>
					))}
			</Route>
		);
	}

	function setRoutes(): ReactElement {
		return (
			<Routes>
				<Route
					path=""
					element={<Navigate to={ROUTER_PATH.portofolio} />}
				/>
				{privateRoutes.map((r: IRoute) => (
					<Route
						key={r.path}
						path={r.path}
						element={<GuardedRoute />}
					>
						<Route key={r.path} path={r.path} element={r.component}>
							{r.child.map((child: IRouteChild) => setGrandChildRoutes(child))}
						</Route>
					</Route>
				))}

				{guestOnlyRoutes.map((r: IRoute) => (
					<Route
						key={r.path}
						path={r.path}
						element={<GuestGuardedRoute />}
					>
						<Route key={r.path} path={r.path} element={r.component}>
							{r.child.map((child: IRouteChild) => (
								<Route
									key={child.path}
									path={child.path}
									element={child.component}
								/>
							))}
						</Route>
					</Route>
				))}

				{routes.map((r: IRoute) => (
					<Route key={r.path} path={r.path} element={r.component}>
						{r.child.map((child: IRouteChild) => (
							<Route
								key={child.path}
								path={child.path}
								element={child.component}
							/>
						))}
					</Route>
				))}

				{privateRouteWithoutSidebar.map((r: IRoute) => (
					<Route key={r.path} path={r.path} element={r.component}>
						{r.child.map((child: IRouteChild) => (
							<Route
								key={child.path}
								path={child.path}
								element={child.component}
							/>
						))}
					</Route>
				))}
				<Route
					path="*"
					element={<Navigate to={ROUTER_PATH.portofolio} />}
				/>
			</Routes>
		);
	}
	let body = <div className="body-login">{setRoutes()}</div>;
	if (isLoggedIn === true) {
		body = <div className="body-content">{setRoutes()}</div>;
	}
	return (
		<BrowserRouter basename="/lender">
			{navIsShown && <NavComponent />}
			{body}
		</BrowserRouter>
	);
};

export default AppComponent;
